export default "__VITE_ASSET__BJNwNGLA__"